/**
 * RP-07 — what a workspace's anomaly-feed settings may be. The Settings form
 * and `PATCH /workspaces/:id/anomaly-settings` both read these, so the form
 * cannot offer a value the route refuses. The DEFAULTS are not here: they are
 * the `anomaly_settings` column defaults, read by the API
 * (`lib/spend-anomalies.ts`) and sent to the client as the effective values.
 */
export const ANOMALY_SEVERITIES = ['low', 'medium', 'high'];
export const ANOMALY_SETTING_BOUNDS = {
    /** A multiple of the vendor's baseline median. Above 1, or every debit is "unusual". */
    ratio: { min: 1.1, max: 100 },
    /** Days of history before a debit that make its baseline. */
    baselineDays: { min: 14, max: 730 },
    /** Prior debits a baseline needs. A median of one is that one debit. */
    minHistory: { min: 2, max: 60 },
    /** The amount from which a known biller's first debit is flagged. */
    newVendorMinAmount: { min: 0, max: 10_000_000 },
};
//# sourceMappingURL=anomaly-settings.js.map